export const SEND_FORM = 'SEND_FORM';
export const SET_FIELD_SUM = 'SET_FIELD_SUM';
export const SET_PAYMENT_SYSTEM = 'SET_PAYMENT_SYSTEM';

export const SET_RESULT_OBJECT = 'SET_RESULT_OBJECT';
export const INIT_STATE = 'INIT_STATE';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/payment/reducers/paymentForm/actionsTypes.js